<template>
    <div class="panel panel-default">
        <div class="panel-body">
            <div class="row">
                <form class="form-horizontal" style="padding-top:10px" id="bs_form" onsubmit="return false;">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">报考专业</label>
                            <div class="col-sm-9">
								<BootstrapCombobox :data="xmList" @change="getKcList" text-field="mc" value-field="id" v-model="query.xmId" placeholder="-报考专业筛选-" :formatOption="(item)=>(item.xmbh+'-'+item.mc)"></BootstrapCombobox>
                            </div>
                        </div>
                    </div>

                   <!-- <div class="col-sm-6" v-if="js=='YWGLY' || js=='ZYPX_YWGLY'">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">学员单位</label>
                            <div class="col-sm-9">
									<BootstrapCombobox :data="dwList" value-field="id" text-field="jgmc" v-model="query.dwId" :format-option="showQyOption"></BootstrapCombobox>
                            </div>
                        </div>
                    </div>-->

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">课程</label>
                            <div class="col-sm-9">
									<BootstrapCombobox :data="kcList" value-field="id" text-field="kcmc" v-model="query.kcId" :format-option="showKcOption"></BootstrapCombobox>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">考生关键字</label>
                            <div class="col-sm-9">
                                <input type="text" name="pcmc" class="form-control" v-model="query.keyword">
                            </div>
                        </div>
                    </div>

                    <div :class="(js=='YWGLY' || js=='ZYPX_YWGLY') ? 'col-sm-12' :'col-sm-6' ">
                        <div class="pull-right">
                            <button @click="search()" type="button" class="btn btn-primary btn-sm" style="margin-right:3px"><i class="fa fa-search" aria-hidden="true"></i>查询</button>
                            <button @click="dc()" type="button" class="btn btn-primary btn-sm"><i class="fa fa-download" aria-hidden="true"></i>导出</button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="row">
                <div class="col-sm-12" style="padding-top: 10px">
                    <BootstrapTable style="font-size: 14px;"
                                    ref="table"
                                    v-once
                                    :columns="columns"
                                    :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:true,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
                                    @onPostBody="vueFormatterPostBody"
                                    @onPageChange="pageChange"
									@onClickRow="clickRow"
                    />
                </div>
            </div>
        </div>
		<ZhiboLearningQkDetail ref="ZhiboLearningQkDetail"></ZhiboLearningQkDetail>
    </div>
</template>
<script>
    /**
     * 直播管理-学生观看情况
     .
     */

    import tableMixin from '@/mixins/table.js';
    import ZhiboLearningQkDetail from './ZhiboLearningQkDetail.vue';//详情
	import qs from "qs";

    export default {
        mixins: [tableMixin],
        name:"ZhiboLearningQkList",
		components :{
			ZhiboLearningQkDetail
		},
        data:function(){
            return {
				js:this.$store.state.user.js,
                query:{
					xmId:'',
					kcId:'',
					dwId:'',
					keyword:''
                },
				xmList:[],
				kcList:[],
				dwList:[],
                columns: [
                    {
                        field: 'state',
                        checkbox: true
                    },
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center',
                        formatter: (value, row, index)=> {
                            var options = this.$refs.table.getOptions();
                            return options.pageSize * (options.pageNumber - 1) + index + 1;
                        }
                    },
                    {
                        field: 'pxzt',
                        title: '报考专业',
                        formatter: (value, row) => {
                            return row.xmbh + '-' + value;
                        }
                    },
                    {
                        field: 'ksxm',
                        title: '姓名'
                    },
                    {
                        field: 'sfzh',
                        title: '身份证号码'
                    },
                    // {
                    //     field: 'dwmc',
                    //     title: '学员单位',
					// 	formatter: (value, row) => {
					// 		return row.dwdm+'-'+row.dwmc;
					// 	}
                    // },
                    {
                        field: 'kcmc',
                        title: '课程',
                    },
                    {
                        field: 'zsc',
                        title: '直播总时长（分钟）'
                    },
                    {
                        field: 'zgksc',
                        title: '考生观看时长（分钟）'
                    },
					{
					    field: 'xxjd',
					    title: '学习进度',
						formatter: (value, row) => {
							if(value){
								return value+"%";
							}
							return "";
						}
					},
					{
					    field: 'fs',
					    title: '成绩'
					},
                    {
                        field: 'actions',
                        title: '操作',
						width:60,
                        formatter: (value, row) => {
                            return this.vueFormatter({
                                template: '<div  class="operation_column">' +
                                    '<a @click="xq(row)">详情</a></div>',
                                data: { row },
                                methods: {
                                    xq: this.xq,
                                }
                            })
                        }
                    }
                ]
            }
        },
       mounted(){
       	this.query = Object.assign(this.query,{current:1,size:10},this.$route.query);
       	this.load();
       },
       beforeRouteUpdate(to, from, next){
		this.query = Object.assign(this.query,{current:1,size:10},to.query);
       	this.load();
       	next();
       },
        created:function(){
            this.$store.commit('setBreadcrumb',[{name:'自学考试'},{name:'日常练习管理'},{name:'直播观看情况'}]);
			this.getPcList();
			this.getKcList();
			// this.getQyList();
		},
        methods: {
			dc:function(){//文件导出下载 标准写法
				this.$confirm('即将按照查询条件导出,确定继续吗？',()=>{
					window.open('/htgl/biz/zypx/zb/xsgkqk/export?'+qs.stringify(this.query));
				});
			},
			getPcList:function(){
			    this.$http.post('/htgl/biz/zypx/zb/xsgkqk/hqpc').then(res=>{
			        if(res.data){
			            this.xmList = res.data || [];
			        }
			    });
			},
			// getQyList:function(){
			//     this.$http.post('/htgl/biz/zypx/zb/xsgkqk/hqqy').then(res=>{
			//         if(res.data){
			//             this.dwList = res.data || [];
			//         }
			//     });
			// },
			getKcList:function(){
				this.query.kcId = '';
			    this.$http.post('/htgl/biz/zypx/zb/xsgkqk/hqkc',{xmId:this.query.xmId}).then(res=>{
			        if(res.data){
			            this.kcList = res.data || [];
			        }
			    });
			},
			showKcOption:function(row){
			    return row.kcdm+'-'+row.kcmc;
			},
			showQyOption:function(row){
			    return row.jgdm+'-'+row.jgmc;
			},
            //详情
            xq:function(row){
				this.$refs.ZhiboLearningQkDetail.open({	xmId:row.xmid,
							kcId:row.kcid,
							ksId:row.ksid});
            },
            //根据查询条件进行检索
            search:function(){
                //将数据表格的页码以及每一页展示的数据重置为1，10
                let query = Object.assign(this.query,{current:1,size:10},{_t:new Date().getTime()});
                this.$router.push({name:this.$route.name,query:query});
            },
            load:function(pageNumber, pageSize){
                this.query.current = pageNumber || this.query.current;
                this.query.size = pageSize || this.query.size;
                this.$http.post('/htgl/biz/zypx/zb/xsgkqk/cx',this.query).then(res=>{
                    let data = res.data;
                    //封装返回值
                    let result= {
                        total: data.total,
                        rows: data.records
                    };
                    //table加载返回的数据
                    this.$refs.table.load(result);
					this.$refs.table.refreshOptions({pageNumber:parseInt(this.query.current),
						pageSize:parseInt(this.query.size)});
                });
            },
            pageChange:function(pageNumber, pageSize){
                let query = Object.assign(this.query,{current:pageNumber,size:pageSize},{_t:new Date().getTime()});
                this.$router.push({name:this.$route.name,query:query});
            }
        }
    }
</script>
<style scoped>

</style>
